import React from "react";
import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Personality from "./Personality";
import Answers from "./Answers";

import formatCamelCase from "../../../../../utilities/formatCamelCase";

const CategoryCards = ({ stats, questions, socialStyles, userId }) => {
  const [categories, setCategories] = React.useState([]);

  React.useEffect(() => {
    // if (categories.length === 0) {
      const c = [];
      // console.log(questions);
      for (let q of questions) {
        let name = q.category;
        let label = formatCamelCase(q.category);
        let stat = getStat(q.category, "percentage")
        c.push({name, label, stat})
      }
      setCategories([...c]);
    // }
  },[questions]);


  const getStat = (category, stat) => {
    try {
      if (stats) {
        return `${stats[category][stat]}%`;
      }
      return "";
    } catch (e) {
      return "";
    }
  };

  const renderCategories = (category) => {

    if (category === 'personality') {
      return <Personality socialStyles={socialStyles}/>
    }
    const qs = questions.filter(q => q.category === category)

    if (qs.length === 0) {
      return <></>
    }

    return <Answers category={category} questions={qs[0].questions} userId={userId}/>



  }

  return (
    <Grid
      container
      // direction="column"
      alignItems="center"
      justifyContent="center"
      spacing={3}
      style={{ width: "100%" }}
    >
      <Grid item style={{ width: 100, height: 100 }}>
        {/* <CircularProgressbar
          value={stats ? stats.totalPercentage : 0}
          text={`${stats ? stats.totalPercentage : 0}%`}
          styles={buildStyles({
            pathColor: "#ef5241",
            textColor: "#ef5241",
            trailColor: "#d6d6d6",
          })}
        /> */}
      </Grid>

      {categories.map((category) => {
        return (
          <Grid item xs={12} key={category?.name}>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="body1"> {category.label} - {category.stat}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {renderCategories(category?.name)}
              </AccordionDetails>
            </Accordion>
          </Grid>
        );
      })}

    </Grid>
  );
};

export default CategoryCards;
